import React, { ReactElement } from "react";
import type { Ref } from "react";
import { View, TextInput, TextInputProps, TextStyle } from "react-native";
import { Text } from "../../components/Text";
import type { KeyboardType } from "react-native/Libraries/Components/TextInput/TextInput";
import { inputTextStyles as styles } from "./styles";
import InputError from "./InputError";

type CustomStyles = {
  inputLabelText?: TextStyle;
  inputText?: TextStyle;
};

export type InputTextProps = {
  inputLabel: string;
  inputRef?: Ref<any>;
  keyboardType?: KeyboardType;
  textTheme?: "dark" | "light";
  lastField?: boolean;
  error?: string;
  showError?: boolean;
  editable?: boolean;
  customStyles?: CustomStyles;
} & TextInputProps;

const InputText = ({
  inputLabel,
  inputRef,
  textTheme = "dark",
  lastField = false,
  error,
  showError = false,
  editable = true,
  customStyles,
  ...additionalProps
}: InputTextProps): ReactElement => {
  const bottomMargin = lastField ? styles.lastField : undefined;
  return (
    <View style={[styles.inputContainer, bottomMargin]}>
      <Text style={[styles.inputLabelText, customStyles?.inputLabelText || {}]}>
        {inputLabel}
      </Text>
      <TextInput
        {...additionalProps}
        ref={inputRef}
        style={[styles.inputText, customStyles?.inputText || {}]}
        editable={editable}
      />
      {showError && <InputError error={error} />}
    </View>
  );
};

export default InputText;
